import { html } from "lit";
var icon_cart_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <g>
      <g>
        <g transform="translate(4 3.93)">
          <path
            d="M17.48 22.57H6.14c-.55 0-1-.45-1-1s.45-1 1-1h11.34a.7.7 0 0 0 .7-.6L21.2 2.26A2.72 2.72 0 0 1 23.87 0h1.12c.55 0 1 .45 1 1s-.45 1-1 1h-1.12a.7.7 0 0 0-.7.59L20.16 20.3a2.77 2.77 0 0 1-.92 1.62c-.49.41-1.11.64-1.75.64Z" />
          <path d="M8.29 26a1.43 1.43 0 1 1 0-2.86V26Z" />
          <path d="M8.29 26v-2.86a1.43 1.43 0 1 1 0 2.86Z" />
          <path d="M16.86 26a1.43 1.43 0 1 1 0-2.86V26Z" />
          <path d="M16.86 26v-2.86a1.43 1.43 0 1 1 0 2.86Z" />
          <path
            d="M19.8 17.42H6.01a4.4 4.4 0 0 1-4.29-3.36L.05 7.44a1.89 1.89 0 0 1 .98-2.12c.25-.12.53-.19.81-.19h19.71c.55 0 1 .45 1 1s-.45 1-1 1H2.04l1.61 6.45c.13.52.44.99.86 1.33.42.33.96.51 1.49.51h13.8c.55 0 1 .45 1 1s-.45 1-1 1Z" />
        </g>
      </g>
    </g>
  </svg>
`;
export {
  icon_cart_default as default
};
//# sourceMappingURL=icon-cart.js.map
